import vmClient from 'app/services/vmClient';
import { Entity, IEntityType, IEntity, EntityStringId } from 'app/types/entity';
import { Image, IImage } from 'app/constants/schemas/Image';

export interface IBannerImage extends IEntity {
  attributes: {
    id: EntityStringId;
    bannerPosition: string;
  };
  associations: {
    image: IImage;
  };
}

export type BannerImage = Entity<IBannerImage>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BannerImage: IEntityType<IBannerImage> = vmClient.defineClass({
  typeName: 'BannerImage',
  version: 3,
  lockable: true,
  persisted: true,
  attributes: {
    bannerPosition: {
      type: 'string',
      notNull: true,
    },
  },
  associations: {
    image: {
      type: Image,
      notNull: true,
    },
  },
});
